import { SkeletonPropsT } from 'baseui/skeleton';
import { Skeleton } from '@tigergraph/app-ui-lib/skeleton';

export function BaseSkeleton({ ...props }: SkeletonPropsT) {
  return <Skeleton {...props} animation />;
}
